<template>
  <v-row>
    <v-col cols="12">
      <ad-header-card
        v-if="!settings.isPaidPlan"
        title="Start your 14 day free trial"
        subtitle="You're one step away from accessing everything CoreCounts has to offer. Let's do this!"
        :image="$images.START_TRIAL"
      >
        <v-list dense class="py-0 transparent">
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="success">check</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="secondarytext--text">
              Try CoreCounts FREE for 14 days, cancel anytime
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="success">check</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="secondarytext--text">
              We'll remind you before your trial ends
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </ad-header-card>
    </v-col>
    <v-col cols="12" sm="6">
      <select-plan-card
        v-on:select="showDialog"
        :planId="$enums.companyPlanTypes.LITE"
      >
      </select-plan-card>
    </v-col>
    <v-col cols="12" sm="6">
      <select-plan-card
        v-on:select="showDialog"
        :planId="$enums.companyPlanTypes.ENGAGEMENT"
      >
      </select-plan-card>
    </v-col>
    <select-plan-dialog ref="selectPlanDialog" v-on:save="$emit('save')">
    </select-plan-dialog>
  </v-row>
</template>

<script>
import AdHeaderCard from "@/components/common/AdHeaderCard";
import SelectPlanCard from "@/components/billing/SelectPlanCard";
import SelectPlanDialog from "@/components/billing/SelectPlanDialog";
import { mapGetters } from "vuex";
export default {
  name: "SelectPlan",
  components: { AdHeaderCard, SelectPlanCard, SelectPlanDialog },
  data: () => ({}),
  computed: {
    ...mapGetters({ profile: "profile/profile", settings: "profile/settings" })
  },
  methods: {
    showDialog(planId) {
      this.$store
        .dispatch("billing/getBillableUserCount")
        .then(() => {
          this.$refs.selectPlanDialog.showDialog(planId);
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading plan."
          );
        });
    }
  }
};
</script>
